/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RevenueShareDetails } from './revenueShareDetails';
import { ServiceFeedBackMap } from './serviceFeedBackMap';
import { ServicePlanModel } from './servicePlanModel';
import { SubscriberResponses } from './subscriberResponses';
import { VasServiceDto } from './vasServiceDto';
import { VerificationServiceFeedBack } from './verificationServiceFeedBack';


export interface CreateVasServicWithServiceTypeDetailsDto { 
    vasServiceInfo?: VasServiceDto;
    serviceProviderId?: string;
    ussdCampaignId?: string;
    smsCampaignId?: string;
    serviceFeedBacks?: Array<ServiceFeedBackMap>;
    verificationServiceFeedBack?: VerificationServiceFeedBack;
    responses?: SubscriberResponses;
    servicePlans?: Array<ServicePlanModel>;
    serviceSpecificDetailsDto?: any;
    partnerContentId?: string;
    partnerName?: string;
    revenueShareDetails?: RevenueShareDetails;
}
